module.exports = __webpack_public_path__ + "img/product7.2dd120e5.png";